import React, { useMemo } from 'react'
import GoogleMapReact, { fitBounds } from 'google-map-react'

import MarkerGoogleMap from 'components/GoogleMap/MarkerGoogleMap'

import LngLatBounds, { LngLat } from 'services/lngLatBounds'

const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY

const getDefaultPropsGM = (coordList) => {
  if (!coordList.length)
    return {
      zoom: 13,
      center: null,
    }
  if (coordList.length === 1)
    return {
      zoom: 14,
      center: {
        lng: coordList[0].lng,
        lat: coordList[0].lat,
      },
    }
  const bounds = coordList?.reduce(function (bound, coord) {
    return bound.extend(new LngLat(coord.lng, coord.lat))
  }, new LngLatBounds())

  const ne = bounds.getNorthEast()
  const sw = bounds.getSouthWest()

  const opt = fitBounds(
    {
      ne,
      sw,
    },
    {
      width: 955,
      height: 340,
    }
  )

  return {
    zoom: opt.zoom,
    center: opt.center,
  }
}

const GoogleMap = ({
  coordsMarkers = [],
  markerHoverId,
  selectedDateRange,
}) => {
  const defaultProps = useMemo(
    () => getDefaultPropsGM(coordsMarkers),
    [coordsMarkers]
  )

  return (
    <div className="google_map_container">
      <GoogleMapReact
        bootstrapURLKeys={{
          key: apiKey,
        }}
        center={defaultProps.center}
        zoom={defaultProps.zoom}
        options={{
          fullscreenControl: false,
          clickableIcons: false,
          keyboardShortcuts: false,
        }}
      >
        {coordsMarkers.map((f, i) => {
          return (
            <MarkerGoogleMap
              key={f.id}
              lat={f.lat}
              lng={f.lng}
              title={i + 1}
              id={f.id}
              name={f.name}
              markerHoverId={markerHoverId}
              selectedDateRange={selectedDateRange}
            />
          )
        })}
      </GoogleMapReact>
    </div>
  )
}

export default GoogleMap
